import IBAN from 'iban';
import {
    createField,
    updateField,
} from '../../actions';
import {
    EVENT_STEP_VALIDATE,
} from '../../helpers/consts';

export class IbanNumberField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Check your IBAN account number'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'text';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--iban-number')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--iban-number');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldInput.addEventListener('input', () => {
            this.$fieldInput.value = this.$fieldInput.value.replace(/[^0-9a-zA-Z\- ]/, '');
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    validate() {
        this.$fieldInput.classList.remove('is-invalid');
        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;

        this.isValid = IBAN.isValid(this.$fieldInput.value);

        if (this.$fieldInput.value === '') {
            this.$fieldInput.classList.add('is-invalid');
            this.isValid = false;
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty.replace(/%s/g, this.label);

            this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
            return;
        }

        if (this.isValid) {
            // Valid credit card number
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
            this.isValid = false;
        }

        if (this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default IbanNumberField;
